import { dataHeartCancel } from 'dls-icons-data'
import { createIcon } from '../common'

const IconHeartCancel = /*#__PURE__*/createIcon(dataHeartCancel)
export default IconHeartCancel
